import { Layout, SkeletonPage } from '@shopify/polaris'
import { SkeletonTable } from '@/components/shared/SkeletonTable'
import { SkeletonChart } from '@/components/shared/SkeletonChart'
import i18next from 'i18next'

const BackordersFallback = () => {
  return (
    <SkeletonPage title={i18next.t('backordersDashTitle')} primaryAction>
      <Layout>
        <Layout.Section>
          <SkeletonChart />
        </Layout.Section>
        <Layout.Section>
          <SkeletonTable />
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  )
}

export { BackordersFallback }
